import styled from "styled-components/macro";
import React, { useEffect, useState } from "react";
import {
  MdArrowBack,
  MdArrowBackIos,
  MdArrowBackIosNew,
  MdMenu,
} from "react-icons/md";

import "../styles/Login.css";
import { useLocation, useNavigate } from "react-router";
import { isEmpty } from "../functions/isEmpty";
import Spinner from "../components/CTA/Spinner";

export default function Login({
  authToken,
  email,
  setEmail,
  password,
  setPassword,
  signIn,
  signUp,
  username,
  setUsername,
  creatorData,
  shoppingCard,
  isMobile,
  isUploading,
  setIsUploading,
  companyData,
  setActiveOrderRedirect,
  activeOrderRedirect,
  setBecomeSellerActive,
}) {
  const [page, setPage] = useState("register");
  const [formIsFilled, setFormIsFilled] = useState(false);
  let loc = useLocation();
  const queryParams = new URLSearchParams(loc.search);
  const becomeSeller = queryParams.get("becomeSeller") === "true";

  let navigate = useNavigate();

  useEffect(() => {
    if (becomeSeller) {
      setBecomeSellerActive(true);
      console.log("true");
    } else {
      setBecomeSellerActive(false);
    }
  }, [becomeSeller]);

  // Attach an event listener when the component mounts
  useEffect(() => {
    const handleKeyDown = (event) => {
      // Check if the pressed key is the Enter key (key code 13)
      if (event.keyCode === 13 && formIsFilled && page == "register") {
        // Call the function when Enter key is pressed
        setIsUploading(true);
        signUp();
      } else if (event.keyCode === 13 && formIsFilled && page != "register") {
        setIsUploading(true);
        signIn();
      }
    };

    // Add event listener to the document
    document.addEventListener("keydown", handleKeyDown);

    // Clean up event listener when the component unmounts
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [formIsFilled, page, username, email, password]);

  // userdata in state packen
  useEffect(() => {
    if (!isEmpty(authToken)) {
      if (activeOrderRedirect) {
        navigate("/checkout");
      } else {
        navigate("/");
      }
    }
  }, [authToken]);

  useEffect(() => {
    if (
      (page == "register" && isEmpty(username)) ||
      isEmpty(email) ||
      isEmpty(password) ||
      !validateEmail(email) ||
      password.length < 6
    ) {
      setFormIsFilled(false);
    } else {
      setFormIsFilled(true);
    }
  }, [username, email, password, page]);

  const signUpAndDisableButton = () => {
    setIsUploading(true);
    signUp();
  };

  const signInAndDisableButton = () => {
    setIsUploading(true);
    signIn();
  };

  const validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

  return (
    <div className="login">
      {isMobile ? (
        <div className="login_topnav">
          {becomeSeller ? (
            <div
              className="login_topnav_left"
              onClick={() => navigate("/becomeseller")}>
              <ArrowBack /> Als Creator:in loslegen
            </div>
          ) : (
            <div className="login_topnav_left" onClick={() => navigate("/")}>
              <ArrowBack /> {page == "login" ? "Einloggen" : "Registrieren"}
            </div>
          )}
        </div>
      ) : (
        <div className="login_topnav">
          {becomeSeller ? (
            <div
              className="login_topnav_left_title"
              onClick={() => navigate("/becomeseller")}>
              <ArrowBack /> Als Creator:in loslegen
            </div>
          ) : (
            <div
              className="login_topnav_left_title"
              onClick={() => navigate("/")}>
              <ArrowBackDesktop />{" "}
              {page == "login" ? "Einloggen" : "Registrieren"}
            </div>
          )}
        </div>
      )}

      {!becomeSeller && (
        <div className="collabodetail_topnav_bottom">
          {page == "login" ? (
            <>
              <div className="collabodetail_topnav_bottom_tab_active">
                Einloggen
              </div>
              <div
                className="collabodetail_topnav_bottom_tab"
                onClick={() => setPage("register")}>
                Neu Registrieren
              </div>
            </>
          ) : (
            <>
              <div
                className="collabodetail_topnav_bottom_tab"
                onClick={() => setPage("login")}>
                Einloggen
              </div>
              <div className="collabodetail_topnav_bottom_tab_active">
                Neu Registrieren
              </div>
            </>
          )}
        </div>
      )}

      {page == "register" ? (
        <div className="login_registerform">
          <div className="login_registerform_title">
            {becomeSeller ? "Creator Account anlegen" : "Neu Registrieren"}
          </div>

          <input
            type="text"
            className="login_input"
            placeholder="Name"
            value={username}
            onChange={(e) => {
              setUsername(e.target.value);
            }}
          />
          <input
            type="email"
            className="login_input"
            placeholder="Email-Adresse"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
            }}
          />
          <input
            type="password"
            className="login_input"
            placeholder="Passwort Mind. 6 Zeichen"
            value={password}
            onChange={(e) => {
              setPassword(e.target.value);
            }}
          />
          {formIsFilled ? (
            <>
              {!isUploading ? (
                <div
                  className="login_ctabtn"
                  onClick={() => signUpAndDisableButton()}>
                  Registrieren{" "}
                </div>
              ) : (
                <div className="login_ctabtn_disabled" disabled={"disabled"}>
                  <Spinner />
                </div>
              )}
            </>
          ) : (
            <div className="login_ctabtn_disabled" disabled={"disabled"}>
              Registrieren
            </div>
          )}
          <div className="">
            {/* username == "" ? "Benutzername muss ausgefüllt werden" : "" */}
          </div>
          {/*
          <div className="login_divider">oder</div>
          <div className="login_sociallogin">Mit Google registrieren</div>
          <div className="login_sociallogin">Mit Facebook registrieren</div>
          */}
        </div>
      ) : (
        <div className="login_registerform">
          <div className="login_registerform_title">Einloggen</div>

          <input
            type="email"
            className="login_input"
            placeholder="Email-Adresse"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
            }}
          />
          <input
            type="password"
            className="login_input"
            placeholder="Passwort"
            value={password}
            onChange={(e) => {
              setPassword(e.target.value);
            }}
          />
          {formIsFilled ? (
            <>
              {!isUploading ? (
                <div
                  className="login_ctabtn"
                  onClick={() => signInAndDisableButton()}>
                  Einloggen{" "}
                </div>
              ) : (
                <div className="login_ctabtn_disabled" disabled={"disabled"}>
                  <Spinner />
                </div>
              )}
            </>
          ) : (
            <div className="login_ctabtn_disabled" disabled={"disabled"}>
              Einloggen{" "}
            </div>
          )}
          {/*
                    <div className="login_divider">oder</div>
          <div className="login_sociallogin">Mit Google einloggen</div>
          <div className="login_sociallogin">Mit Facebook einloggen</div>
        
          */}
        </div>
      )}
    </div>
  );
}

const MenuIcon = styled(MdMenu)`
  font-size: 33px;
  color: #575757;
`;

const ArrowBack = styled(MdArrowBackIosNew)`
  font-size: 23px;
  color: #474747;
`;

const SearchIcon = styled(MdArrowBackIos)`
  font-size: 20px;
  color: #ffffff;
  transform: rotate(-90deg);
  margin-top: -8px;
`;

const ArrowBackIcon = styled(MdArrowBackIos)`
  font-size: 23px;
  color: #474747;
`;

const ArrowBackDesktop = styled(MdArrowBackIosNew)`
  font-size: 23px;
  color: #474747;
  margin-bottom: -5px;
  margin-right: 5px;
`;
